import {CancelButton, ModalBase, Text} from '../1elements'
import ApproveButton from '../1elements/Buttons/TextButtons/ApproveButton'
import Box from '@mui/material/Box'

const ApproveModal = ({open, setOpen, approveHandler}) => {
    const closeHandler = () => {
        setOpen(false)
    }
    return(
        <ModalBase open={open} setOpen={setOpen} sx={{ padding: '30px' }}>
            <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                <Text>Are you sure you want to approve the record?</Text>
                <Text>This action cannot be undone</Text>
            </Box>
            <Box sx={{ display: 'flex', margin: '20px auto 0', width: '200px' }}>
                <CancelButton onClick={closeHandler} />
                <ApproveButton onClick={approveHandler} />
            </Box>
        </ModalBase>
    )
}

export default ApproveModal
